import Config from '@config';
import {
  createRolesHooks,
  initializeRolesApi,
} from '@gasbi/shared/common/features/roles';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import {
  mainOrganizationApi,
  useGetCachedRoleByIdSelector as useGetCachedMainOrgRoleByIdSelector,
} from '../mainOrganization';
import {
  organizationsApi,
  useGetCachedRoleByIdSelector as useGetCachedOrgRoleByIdSelector,
} from '../organizations';
import { isRootRole } from './utils';

export const {
  useGetSystemRolesQuery,
  useGetRolesQuery,
  useGetRoleByIdQuery,
  useSaveRoleMutation,
  useAssignRoleMutation,
  useSuspendRoleMutation,
  useGetCachedRoleByIdSelector,
} = createRolesHooks(
  organizationsApi,
  mainOrganizationApi,
  useGetCachedOrgRoleByIdSelector,
  useGetCachedMainOrgRoleByIdSelector,
  isRootRole,
);

export const {
  rolesApi,
  useGetRolePermissionsByIdQuery,
  useGetRoleAvailablePermissionsByIdQuery,
  useAssignRoleByIdMutation,
  useSuspendRoleByIdMutation,
} = initializeRolesApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export * from './rolesApi';
